const employeeResource = {
    title: "Employees",
    singular: "Employee",
    searchFields: [
        "fullName",
        "personCode",
        "employee.employeeCode",
        "payClassName",
        "employmentStatusName"
    ],
    columns: [
        {
            field: "fullName",
            header: "Employee"
        },
        {
            field: "employee.employeeCode",
            header: "Employee Code"
        },
        {
            field: "payClassName",
            header: "Pay Class"
        },
        {
            field: "employmentStatusName",
            header: "Employment Status"
        },
        {
            field: "employee.dateHired",
            header: "Date Hired"
        }
    ]
};

export default employeeResource;
